import { useMemo, type Dispatch, type SetStateAction, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { type Filters } from '..'
import { Table, type Column } from '../../../../components/Table'
import { useExpertsQuery } from '../../../../services/hooks/experts/queries/useExpertQuery'
import { mapExpertDomainDataToTableRow } from '../utils/mapExpertDomainDataToTableRow'

type Props = {
  columns: Column[]
  filters: Filters
  setFilters: Dispatch<SetStateAction<Filters>>
  showExpertBioButton?: boolean
}

export const ViewExpertsWithManualPagination = ({
  columns,
  filters,
  setFilters,
  showExpertBioButton = false,
}: Props) => {
  const navigate = useNavigate()
  const { data, isLoading, refetch } = useExpertsQuery(filters)

  const rows = useMemo(
    () => data?.data?.map(mapExpertDomainDataToTableRow),
    [data]
  )

  useEffect(() => {
    refetch()
  }, [])

  return (
    <Table
      columns={columns}
      rows={rows || []}
      isLoading={isLoading}
      currentPage={filters.page}
      registersPerPage={filters.take}
      perPageOptions={[5, 10, 15, 20, 50]}
      paginationMode="manual"
      compactListingFont
      totalCountOfRegisters={data?.meta.itemCount || 0}
      noContentMessage="Sem registro de usuário(s)"
      onRowClick={(id) =>
        window.open(`/painel/database/${id}`, '_blank', 'noopener,noreferrer')
      }
      onChangingRegistersPerPage={(registersPerPage) => {
        localStorage.setItem(
          'databaseInfoPerPageNumber',
          JSON.stringify(registersPerPage)
        )
        const storageFilters = localStorage.getItem('filters')

        if (storageFilters) {
          const parsedStorageFilters = JSON.parse(storageFilters)
          localStorage.setItem(
            'filters',
            JSON.stringify({
              ...parsedStorageFilters,
              take: registersPerPage,
            })
          )
        }

        setFilters((prevState) => ({
          ...prevState,
          page: 1,
          take: registersPerPage,
        }))
      }}
      onPageChange={(pageNumber: number) =>
        setFilters((prevState) => ({
          ...prevState,
          page: pageNumber,
        }))
      }
      showExpertBioButton={showExpertBioButton}
    />
  )
}
